// data.js

export const statesAndLGAs = [
  {
    id: 1,
    name: "Abia",
    lgas: [
      "Aba North",
      "Aba South",
      "Arochukwu",
      "Bende",
      "Ikwuano",
      "Isiala-Ngwa North",
    ],
  },
  {
    id: 2,
    name: "Adamawa",
    lgas: ["Ikeja", "Epe", "Ikorodu"],
  },
];

export const coordinatorRoles=[
  {id:2,name:'Federal Coordinator'},
  // {id:3,name:'Zonal Coordinator'},
  // {id:4,name:'State Coordinator'},
  // {id:5,name:'Lga Coordinator'},
  // {id:6,name:'Ward Coordinator'},
]
export const zonesAndStates = [
  {
    id: 1,
    name: " NorthCentral",
    states: ["Benue", "Kogi", "Kwara", "Nasarawa", "Niger", "Plateau"],
  },
  {
    id: 2,
    name: "NorthEast",
    states: ["Adamawa", "Bauchi", "Borno", "Gombe", "Taraba", "Yobe"],
  },
  {
    id: 3,
    name: "NorthWest",
    states: [
      "Kaduna",
      "Kano",
      "Katsina",
      "Kebbi",
      "Jigawa",
      "Sokoto",
      "Zamfara",
    ],
  },
  {
    id: 4,
    name: "SouthEast",
    states: ["Abia", "Anambra", "Enugu", "Ebonyi", "Imo"],
  },
  {
    id: 5,
    name: "SouthSouth",
    states: ["Akwa Ibom", "Bayelsa", "Cross River", "Delta", "Edo", "Rivers"],
  },
  {
    id: 6,
    name: "SouthWest",
    states: ["Ondo", "Osun", "Oyo", "Ekiti", "Lagos", "Ogun"],
  },
];
